import React from 'react';
import { StyleSheet, View } from 'react-native';

import { spacing, theme } from '../../constants/theme';
import { Text, TextInput } from '../../core-ui';

import { UploadFieldInput } from './UploadFileInput';

export function TourParticipantBox({
  data,
  title,
  onChangePassport,
  onChangePhoneNumber,
  onChangename,
  onChangeIdentification,
  onChangePassPhoto,
  disabled,
}: {
  data: {
    identification: string;
    name: string;
    passport: string;
    phoneNumber: string;
    passPhoto: string;
  };
  title: string;
  onChangename: (text: string) => void;
  onChangePhoneNumber: (text: string) => void;
  onChangeIdentification: (newImageUrl: string) => void;
  onChangePassport: (newImageUrl: string) => void;
  onChangePassPhoto: (newImageUrl: string) => void;
  optional?: boolean;
  disabled?: boolean;
}) {
  return (
    <View style={styles.participantBox}>
      <Text>{title}</Text>
      <TextInput
        containerStyle={styles.marignTop12}
        data-testid="full-name"
        value={data.name}
        onChangeText={onChangename}
        label={t(['Nama Lengkap', 'Full Name'])}
        required={!data.name}
        disabled={disabled}
      />
      <TextInput
        containerStyle={styles.marignTop12}
        data-testid="phone-number"
        value={data.phoneNumber}
        onChangeText={(text) => {
          onChangePhoneNumber(text.replace(/[^0-9]/g, ''));
        }}
        label={t(['Nomor HP', 'Phone Number'])}
        inputMode="numeric"
        required={!data.phoneNumber}
        disabled={disabled}
      />
      <UploadFieldInput
        title={'KTP ' + title}
        fileUrl={data.identification}
        onFileSelected={onChangeIdentification}
        disabled={disabled}
        titleStyle={{ size: 'xs' }}
        inputAccept=".jpg"
        containerStyle={styles.marignTop12}
        required
      />
      <UploadFieldInput
        title={'Passport ' + title}
        fileUrl={data.passport}
        onFileSelected={onChangePassport}
        disabled={disabled}
        titleStyle={{ size: 'xs' }}
        inputAccept="application/pdf"
        containerStyle={styles.marignTop12}
        required
      />
      <UploadFieldInput
        title={'Pass Foto 3,3 x 4,8 cm ' + title}
        fileUrl={data.passPhoto}
        onFileSelected={onChangePassPhoto}
        disabled={disabled}
        titleStyle={{ size: 'xs' }}
        inputAccept="application/pdf"
        containerStyle={styles.marignTop12}
        required
      />
    </View>
  );
}

const styles = StyleSheet.create({
  participantBox: {
    backgroundColor: theme.colors.background.boxGrey,
    borderWidth: 1,
    padding: spacing.m,
    marginTop: spacing.s,
    borderColor: theme.colors.border.primary,
  },
  marignTop12: { marginTop: spacing.s, width: '100%' },
});
